module.exports = __webpack_public_path__ + "media/images/icon/like-981fbf98dda3969e22bfbe1c3dd1262e.svg";